import React, { Component } from 'react'
import './About.css'

class About extends Component {
    render() {
        return (
            <div className='about'>
                <p>This app was inspired by personal experience having to plan a night out with friends or family
                    and having people not have an idea of where to go first. We ar based in Austin, Texas and we
                    know people that have come and don't know what to visit, well, this will help everyone know where
                    to go and visit and have a plan. Utilizing this app will help group of people come together to
                    start the night and knowing at all times where to head next after leaving a bar or restaurant.
                </p>
            </div>
        )
    }
}

export default About;